/* eslint no-shadow: "off", no-param-reassign: ["error", { "props": false }], no-console: "off", quotes: "off" */

export default {
  setMaximunmDigitsLenght(state, payload) {
    state.maximumDigitsPinLength = payload.value;
  },
  registerModal(state, payload) {
    state.activeModals.push(payload.value);
  },
  emptyActiveModalsStack(state) {
    state.activeModals = [];
  },
  unregisterModal(state) {
    state.activeModals.pop();
  },
  setHowItWinType(state, payload) {
    state.howItWinType = payload;
  },
  storePrizeSectionEnabledAtLeaderBoard(state, payload) {
    state.hidePrizeSectionEnabledAtLeaderBoard = payload.value;
  },
  storePushNotificationsPublicKey(state, payload) {
    state.pushNotificationsPublicKey = payload.value;
  },
  setInviteConfig(state, payload) {
    state.inviteConfig = payload.value;
  },
  setTotalAchievements(state, payload) {
    state.userDetails = {
      ...state.userDetails,
      achievements: payload.value,
    };
  },
  updateFreeTrialGuaranteedPrize(state, payload) {
    state.freeTrialGuaranteedPrize = payload.value;
  },
  updateFreeTrialPoints(state, payload) {
    state.freeTrialPoints = payload.value;
  },
  updateFreeTrialPrice(state, payload) {
    state.freeTrialPrice = payload.value;
  },
  updateFreeTrialRedirectionUrl(state, payload) {
    state.freeTrialRedirectionUrl = payload.value;
  },
  updateOptOutFromHome(state, payload) {
    state.showOptOutPhase = payload.value;
  },
  setFreeTrialUserPrice(state, payload) {
    state.freeTrialUserPrice = payload;
  },
  resetCode(state) {
    state.code = null;
  },
  updateCode(state, payload) {
    state.code = payload.code;
  },
  validTransitionForFreeGameMethod(state, payload) {
    state.validTransitionForFreeGame = payload;
  },
  resetUnauthorizedMsisdn(state) {
    state.unauthorizedMsisdn = null;
  },
  updateUnauthorizedMsisdn(state, payload) {
    state.unauthorizedMsisdn = payload.unauthorizedMsisdn;
  },
  setJackpotCountdownDay(state, payload) {
    state.jackpotCountdownDay = payload.value;
  },
  updateWonPrizes(state, payload) {
    state.userDetails.wonPrizes = payload.prizes;
  },
  storeUserAvailableCoins(state, payload) {
    state.userDetails.availableCoins = payload.availableCoins;
  },
  setSecForMatchedCards(state, payload) {
    state.secForMatchedCards = payload.value;
  },
  setMinGamesToPlay(state, payload) {
    state.minGamesToPlay = payload.value;
  },
  setTimeRoundIntro(state, payload) {
    state.timeRoundIntro = payload.value;
  },
  updateCPC(state, payload) {
    state.cpc = payload.cpc;
  },
  setSingleOptinEnabled(state, payload) {
    state.hasSingleOptIn = payload.value;
  },
  setShowMsisdnInProfilePage(state, payload) {
    state.showMsisdnInProfilePage = payload.value;
  },
  setCorrelationId(state, payload) {
    state.correlationId = payload.value;
  },
  setHideChangePassword(state, payload) {
    state.hideChangePassword = payload.value;
  },
  setHideJackpot(state, payload) {
    state.hideJackpot = payload.value;
  },
  setShowSelectOperatorModal(state, payload) {
    state.showSelectOperatorModal = payload.value;
  },
  setIntegrationInfo(state, payload) {
    state.availableIntegrations[payload.value.name].info = payload.value.data;
  },
  setHideLangSelection(state, payload) {
    state.hideLangSelection = payload.value;
  },
  setTimeWinnerIndication(state, payload) {
    state.timeWinnerIndication = payload.value;
  },
  setHideLeaderboard(state, payload) {
    state.hideLeaderboard = payload.value;
  },
  setPurchaseBundleFromUnsubUser(state, payload) {
    state.purchaseBundleFromUnsubUser = payload.value;
  },
  setIntegrationHeader(state, payload) {
    state.integrationHeader = payload.value;
  },
  setMergedParam(state, payload) {
    state.mergedParam = payload.value;
  },
  setOneTimeSubscriptionBundleId(state, payload) {
    state.oneTimeSubscriptionBundleId = payload;
  },
  setDefaultDailySubButtonEnabled(state, payload) {
    state.defaultDailySubButtonEnabled = payload;
  },
  setReoptinOptoutConfig(state, payload) {
    state.reoptinAndOptoutConfig = payload.value;
  },
  storeHidePrizePage(state, payload) {
    state.hidePrizePage = payload.value;
  },
  storePurchaseViaSMS(state, payload) {
    state.purchaseViaSMS = payload.value;
  },
  setFbAppId(state, payload) {
    document.getElementById('fb:app_id').content = payload.value;
    state.fbAppId = payload.value;
  },
  setVersionInfo(state, payload) {
    state.versionInfo = payload.value;
  },
  storeWinnersShowMsisdn(state, payload) {
    state.winnersShowMsisdn = payload.value;
  },
  storeDuelSkin(state, payload) {
    state.duelSkin = payload.value;
    state.isBrandedProject = state.brandedProjectsBasedOnSkin.some(skin => skin === payload.value);
  },
  storeTimeRounds(state, payload) {
    state.roundTimeList = payload.value;
  },
  updateMultiOperatorOrdinal(state, payload) {
    state.multiOperatorInfo.multiOperatorOrdinal = payload.value;
  },
  setMultiOperatorDisplayNames(state, payload) {
    state.multiOperatorInfo.multiOperatorDisplayNames = payload.value;
  },
  setOperator(state, payload) {
    state.multiOperatorInfo.operatorPicked = payload.value;
  },
  storeOperatorIndex(state, payload) {
    state.operatorIndex = payload;
  },
  setMultiOperator(state, payload) {
    state.multiOperatorInfo.multiOperatorEnabled = payload.value;
  },
  setMultiOperatorKeys(state, payload) {
    state.multiOperatorInfo.multiOperatorKeys = payload.value;
  },
  setMultiOperatorDisplayedNamesInRegisterPage(state, payload) {
    state.multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage = payload.value;
  },
  setHideWinners(state, payload) {
    state.hideWinners = payload.value;
  },
  storeBanner(state, payload) {
    state.banner = payload.value;
  },
  setHideStore(state, payload) {
    state.hideStore = payload.value;
  },
  setSmsAutomaticResponse(state, payload) {
    state.smsAutomaticResponse = payload.value;
  },
  setDisplayPrice(state, payload) {
    state.displayPrice = payload.value;
  },
  storeFacebookFunctionality(state, payload) {
    state.facebookFunctionality = payload.value;
  },
  setLastRandomRound(state, payload) {
    state.lastRandomRound = payload.value;
  },
  storeUserAvatar(state, avatar) {
    state.userAvatar = avatar;
  },
  updateUsername(state, value) {
    state.userDetails.username = value;
  },
  setDisplayAvatar(state, payload) {
    state.userDetails.displayAvatar = payload.item;
    if (state.userDetails.displayAvatar === true) {
      state.userAvatar = state.userDetails.avatar;
    } else {
      state.userAvatar = state.userDetails.facebookImage;
    }
  },
  storeUserDetailsFromDuel: (state, payload) => {
    // Everything that is used from duel db
    state.userDetails.id = payload.id;
    state.userDetails.level = payload.userLevel;
    state.userDetails.username = payload.userId;
    state.userDetails.msisdn = payload.msisdn;
    state.userDetails.facebookId = payload.facebookId;
    state.userDetails.avatarGender = payload.avatarGender;
    state.userDetails.avatar = payload.avatar;
    state.userDetails.facebookImage = payload.facebookImage;
    state.userDetails.displayAvatar = payload.displayAvatar;
    if (state.userDetails.displayAvatar === true) {
      state.userAvatar = payload.avatar;
    } else {
      state.userAvatar = payload.facebookImage;
    }
    state.userDetails.availableGames = payload.availableGames;
    state.userDetails.hasPassword = payload.password === 'true';
  },
  updateDisplayAvatar(state, avatar) {
    state.userDetails.displayAvatar = avatar;
  },
  facebookReferral(state, payload) {
    state.fbReferral = payload.fbRef;
  },
  updateTwoStepRegistration(state, payload) {
    state.twoStepRegistration = payload.value;
  },
  updateSimpleRegistration(state, payload) {
    state.simpleRegistration = payload.value;
  },
  storeConnectionPoints(state, payload) {
    state.connectionPoints = payload.value;
  },
  updateReoptinOnestep(state, payload) {
    state.reoptinOnestep = payload.value;
  },
  storeFacebookImage(state, facebookImage) {
    state.userDetails.facebookImage = facebookImage;
  },
  deletePreviousFacebookImage(state) {
    state.userDetails.facebookImage = '';
  },
  updateRefUrl(state, payload) {
    state.refUrl = payload.refUrl;
  },
  updateCampaignId(state, payload) {
    state.campaignId = payload.campaignId;
  },
  updatePublisherId(state, payload) {
    state.publisherId = payload.publisherId;
  },
  storeClickid(state, payload) {
    state.clickid = payload.clickid;
  },
  updateSplashUrl(state, payload) {
    state.splashUrl = payload.value;
  },
  updateSplashTimer(state, payload) {
    state.splashTimer = payload.value;
  },
  setProfilePath(state, boolean) {
    state.profilePath = boolean;
  },
  setNewAvatarGender(state, avatarGender) {
    state.userDetails.avatarGender = avatarGender;
  },
  storeAvatar(state, avatar) {
    state.userDetails.avatar = avatar;
  },
  deletePreviousAvatar(state) {
    state.userDetails.avatar = '';
  },
  storeModalForHomePage(state, modal) {
    if (modal && modal.name === 'resubscribe-game' && state.userDetails.gamesPlayed < state.minGamesToPlay) return;
    state.modalForHomePage = modal;
  },
  storeModalForStore(state, modal) {
    if (modal && modal.name === 'resubscribe-game' && state.userDetails.gamesPlayed < state.minGamesToPlay) return;
    state.modalForStore = modal;
  },
  storeModalForSettings(state, modal) {
    state.modalForSettings = modal;
  },
  updateAvatarGrouping(state, payload) {
    state.avatarGrouping = payload.value;
  },
  updatePinForBundles(state, payload) {
    state.pinForBundles = payload.value;
  },
  updateSubAndUnsubViaSMS(state, payload) {
    state.subAndUnsubViaSMS = payload.value;
  },
  updateFreeTrialStripe(state, payload) {
    state.freeTrialStripe = payload.value;
  },
  updateLogoOnFooter(state, payload) {
    state.logoOnFooter = payload.value;
  },
  updateCheckBox(state, payload) {
    state.checkBoxEnabled = payload.value;
  },
  updateCookiesPopUp(state, payload) {
    state.cookiesPopUpEnabled = payload.value;
  },
  updateTrackingId(state, payload) {
    state.trackingId = payload.value;
  },
  updateVatBanner(state, payload) {
    state.vatBanner = payload.value;
  },
  updateFacebookPixelId(state, payload) {
    state.facebookPixelId = payload.value;
  },
  storeParameters(state, payload) {
    state.clickid = payload.parametersAdAgency.clickid;
  },
  setUserLanguage(state, payload) {
    state.userDetails.language = payload.userLanguage;
  },
  setSoundsOnOrOff(state, soundsOn) {
    state.soundsOn = soundsOn;
  },
  updateSoundsStatusFromLocaleStorage(state) {
    state.soundsOn = localStorage.getItem('soundsOn') === "true";
  },
  storeUserDetails(state, userDetails) {
    Object.assign(state.userDetails, userDetails);
  },
  storeUserMSISDN(state, payload) {
    state.userDetails.msisdn = payload.msisdn;
  },
  setUserSubscribed(state, payload) {
    state.userDetails.subscribed = payload.subscribed;
  },
  storeUserAvailableGames(state, payload) {
    state.userDetails.availableGames = payload.availableGames;
  },
  storeUserLevel(state, level) {
    state.userDetails.level = level;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/common/mutations.js